import React, { useEffect, useRef, useState } from "react";
import { useDocumentTitle } from "../../hooks/customDocumentTitleHook";
import { useLocation, useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { capitalizeFirstLetter, getPractice, notify } from "../../helpers";
import QRCode from "qrcode.react";
import { loadAppointmentLink } from "../../services/appointment";

export default function FormQRScanner() {
  const [appointmentPortalLink, setAppointmentPortalLink] = useState('');
  const navigate = useNavigate();
  const contentRef = useRef();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const scannerType = queryParams.get('type');
  const accountId = getPractice("account_id");
  const practiceWebsite = getPractice("website");
  const practicePlaceId = getPractice("google_map_place_id");

  useEffect(() => {
    if (practiceWebsite == null || !practiceWebsite) {
      notify("error", "Something went wrong", 0.5);
      navigate(-1);
    } else if (practicePlaceId == null || !practicePlaceId) {
      notify("error", "Something went wrong", 0.5);
      navigate(-1);
    }
  }, [navigate, practiceWebsite, practicePlaceId]);

  useEffect(() => {
    if(scannerType === 'appointment'){
      getAppointmentLink(accountId);
    }
  }, [scannerType, accountId]);

  const getAppointmentLink = async (accountID) => {
    try {
      const response = await loadAppointmentLink(accountID);
      if(response) {
        if(response?.detail) {
          notify("error", response?.detail);
        } else {
          setAppointmentPortalLink(response.data);
        }
      }
    } catch (error) {
      // console.log("🚀 ~ getAppointmentLink ~ error:", error);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const handleCloseWindow = () => {
    window.close();
  };

  const downloadPdf = () => {
    const content = contentRef.current;
    html2canvas(content).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      heightLeft -= pdfHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      pdf.save(`${capitalizeFirstLetter(scannerType)} QR Code.pdf`);
    });
  };

  useDocumentTitle(`${capitalizeFirstLetter(scannerType)} QR Code`);

  return (
    <>
        <div ref={contentRef} className="docpro_signout_wrap" style={{ maxWidth: '21cm' }}>
          <div className="docpro_signout">
            <div style={{ marginTop: '15px' }}>
              <h1 style={{ fontWeight: 'bold', fontSize: '36px', textAlign: 'center' }}>{getPractice("account_name")}</h1>
              <h4 style={{ fontWeight: 'bold', fontSize: '26px', textAlign: 'center', marginBottom: 0 }}>
                {scannerType === 'appointment' ?
                  'Appointment Form'
                : scannerType === 'review' ? 
                  'Google Review'
                : scannerType === 'advanced_directive' ? 
                  'Advanced Directive Form'
                : scannerType === 'hipaa_consent' ? 
                  'HIPAA Consent Form'
                : scannerType === 'older_care' ? 
                  'Older Care Form'
                : scannerType === 'patient_intake' ? 
                  'Patient Intake Form'
                : scannerType === 'patient_survey' ? 
                  'Patient Feedback Survey'
                : scannerType === 'dot_physical' ? 
                  'DOT Physical Form'
                : scannerType === 'community_assessment' ? 
                  'Community Assessment Form'
                : scannerType === 'immunization' ? 
                  'Immunization Consent Form'
                :
                  ''
                }
              </h4>

              <div style={{ width: '80%', height: '21cm', margin: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{ width: '100%', textAlign: 'center' }}>
                  <div style={{ marginBottom: '70px' }}>
                    <h4 style={{ display: 'inline-flex', position: 'relative', margin: 0, padding: '10px 33px', border: '2px solid #a1a1a1', borderBottom: 0, borderRadius: '0 0 3px 3px', background: '#a1a1a1', color: '#FFFFFF' }}>Scan Me
                      <p style={{ position: 'absolute', bottom: '-24px', left: '-1%', width: 0, height: 0, borderLeft: '86px solid transparent', borderRight: '86.5px solid transparent', borderTop: '25px solid #a1a1a1', margin: 0 }}></p>
                    </h4>
                  </div>
                  <div>
                    { (scannerType === 'appointment' && practiceWebsite !== null && practiceWebsite ) ? 
                      <QRCode value={`${appointmentPortalLink}`} size={550} />
                    : (scannerType === 'review' && practicePlaceId !== null && getPractice("google_map_place_id")) ? 
                      <QRCode value={`https://search.google.com/local/writereview?placeid=${practicePlaceId}`} size={550} />
                    : (scannerType === 'advanced_directive' && practicePlaceId !== null && (practiceWebsite)) ? 
                      <QRCode value={`${practiceWebsite}/advanced-directive-form`} size={550} />
                    : (scannerType === 'hipaa_consent' && practicePlaceId !== null && (practiceWebsite)) ? 
                      <QRCode value={`${practiceWebsite}/hipaa-consent-form`} size={550} />
                    : (scannerType === 'older_care' && practicePlaceId !== null && (practiceWebsite)) ? 
                      <QRCode value={`${practiceWebsite}/older-care-form`} size={550} />
                    : (scannerType === 'patient_intake' && practicePlaceId !== null && (practiceWebsite)) ? 
                      <QRCode value={`${practiceWebsite}/patient-intake-form`} size={550} />
                    : (scannerType === 'patient_survey' && practicePlaceId !== null && (practiceWebsite)) ? 
                      <QRCode value={`${practiceWebsite}/patient-survey-form`} size={550} />
                    : (scannerType === 'dot_physical' && practicePlaceId !== null && (practiceWebsite)) ? 
                      <QRCode value={`${practiceWebsite}/dot-physical-form`} size={550} />
                    : (scannerType === 'community_assessment' && practicePlaceId !== null && (practiceWebsite)) ? 
                      <QRCode value={`${practiceWebsite}/community-assessment-form`} size={550} />
                    : (scannerType === 'immunization' && practicePlaceId !== null && (practiceWebsite)) ? 
                      <QRCode value={`${practiceWebsite}/immunization-form`} size={550} />
                    :
                      <p className="docpro_red_color">QR Code Not Found</p>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="docpro_invoice_btns docpro_hide_print">
            <button
              className="docpro_invoice_btn docpro_color3 close_button"
              onClick={handleCloseWindow}
            >
              <span className="docpro_btn_icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
              </span>
              <span className="docpro_btn_text">Close</span>
            </button>

            <button
              className="docpro_invoice_btn docpro_color1"
              onClick={handlePrint}
            >
              <span className="docpro_btn_icon">
                <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512" >
                  <path d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} />
                  <rect x={128} y={240} width={256} height={208} rx="24.32" ry="24.32" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} />
                  <path d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} />
                  <circle cx={392} cy={184} r={24} fill="currentColor" />
                </svg>
              </span>
              <span className="docpro_btn_text">Print</span>
            </button>
            <button
              id="docpro_download_btn"
              className="docpro_invoice_btn docpro_color2"
              onClick={downloadPdf}
            >
              <span className="docpro_btn_icon">
                <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512" >
                  <path d="M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56M192 400.1l64 63.9 64-63.9M256 224v224.03" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={32} />
                </svg>
              </span>
              <span className="docpro_btn_text">Download</span>
            </button>
          </div>
        </div>
    </>
  );
}
